<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>
      <v-card-text fluid class="centered-tabs mt-3 mx-1" >
        <TaskDocumentationForm
            @closeDialog="closeDialog"
            :view-only="facilityMode"
            :hide-button="facilityMode"
            ref="taskDocumentationForm" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import TaskDocumentationForm from '@/modules/book/views/task/components/TaskDocumentationForm.vue';

export default {
  name: 'OfferDocumentationDialog',
  components: {TaskDocumentationForm},
  props: {
    facilityMode: Boolean
  },
  data() {
    return {
      dialog: false,
      viewOnly: true
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$refs.taskDocumentationForm.clearForm();
      this.$emit('closeDialog');
      this.viewOnly = true;
    },
    openCreationDialog(taskInfo) {
      this.dialog = true;
      this.viewOnly = false;
      this.$refs.taskDocumentationForm.setCreateData(taskInfo);
    },
    openDialog(item) {
      this.dialog = true
      if (!item) {
        return;
      }
      this.$refs.taskDocumentationForm.setEditData(item);
    }
  }
}
</script>